import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'
import theme from 'src/utils/styles/theme'

export const Container = styled.div`
  width: 100%;
  display: flex;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.8) 100%),
    ${theme.orange};
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 24px 64px 48px 64px;
  width: 100%;
  @media (max-width: ${breakpoints.m}px) {
    padding: 32px 16px;
  }
`

export const Header = styled.header`
  color: ${theme.textDarker};
  font-family: 'P22MackinacProBook';
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px; /* 133.333% */
  margin-bottom: 20px;
  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
  }
`

export const FeaturesContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  @media (max-width: ${breakpoints.m}px) {
    flex-direction: column;
    width: 100%;
  }
`

export const FeatureCardContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-right: 20px;
  @media (max-width: ${breakpoints.m}px) {
    margin-bottom: 20px;
  }
`

export const IconColumn = styled.div`
  width: 80px;
  height: 80px;
  min-width: 70px;
  @media (max-width: ${breakpoints.m}px) {
    width: 60px;
    height: 60px;
    min-width: 60px;
  }
`

export const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
  }
`

export const TitleText = styled.div`
  color: #000;
  font-family: 'MatterRegular';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19.682px; /* 109.346% */
  margin-bottom: 7px;
`
export const Copy = styled.div`
  color: ${theme.textRegular};
  font-family: 'MatterRegular';
  font-size: 14px;
  font-style: normal;
  font-weight: 100;
  line-height: 20px; /* 125% */
`

export const Link = styled.a`
  color: #000;
  font-family: 'MatterRegular';
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`
// Height should made the line height of the link to prevent mismatched icon sizes
export const LinkPlaceholder = styled.div`
  width: 100%;
  height: 20px;
  visibility: hidden;
`
